<template>
    <ModalBase v-show="visible" @close="cancel" :with-content="true">
        <h1>{{ currentTrad.title }}</h1>
        <section>
            <div>
                <label>{{ currentTrad.position }} x :</label>
                <NumberInput :value="offsetX" @change="changePositionX" />
                mm
            </div>

            <div>
                <label>{{ currentTrad.position }} y :</label>
                <NumberInput :value="offsetY" @change="changePositionY" />
                mm
            </div>
        </section>
        <footer>
            <ClientColorButton @click="validate">{{ $trad.common.ok }}</ClientColorButton>
            <ClientColorButton @click="cancel">{{ $trad.common.cancel }}</ClientColorButton>
        </footer>
    </ModalBase>
</template>

<script>
function hasOnlyBoardFixing(selection) {
    for (let element of selection) {
        if (!(element.element instanceof BoardFixing)) {
            return false;
        }
    }
    return true;
}

function updateFixing() {
    if (this.visible)
        for (let fixing of this.fixings) {
            fixing.element.update({
                x: (fixing.initialX + this.offsetX) / Context.rescaleFactor,
                y: (fixing.initialY + this.offsetY) / Context.rescaleFactor
            });
        }
}
let moveItemsWidget;
window.moveItems = function moveItems(data, onValidate, onCancel) {
    moveItemsWidget.visible = true;
    moveItemsWidget.onValidate = onValidate;
    moveItemsWidget.onCancel = onCancel;
};
import NumberInput from "@/plano/components/number-input";
import ModalBase from "@/components/modal/ModalBase";
import ClientColorButton from "@/components/ui/ClientColorButton";
import { Context } from "plano_engine";

export default {
    data: () => ({
        visible: false,
        onValidate: undefined,
        onCancel: undefined,
        fixings: [],
        offsetX: 0,
        offsetY: 0
    }),
    components: {
        ModalBase,
        NumberInput,
        ClientColorButton
    },
    watch: {
        visible() {
            if (this.visible) {
                let selection = Context.selection.workingSelection.map(element => ({ element, initialX: element.posX, initialY: element.posY }));
                /* Check if we have only BoardFixing in the selection */
                if (!hasOnlyBoardFixing(selection)) {
                    this.cancel();
                } else {
                    Context.memento.open();
                    this.fixings = selection;
                }
            }
        },
        offsetX: updateFixing,
        offsetY: updateFixing
    },
    computed: {
        currentTrad() {
            return this.$trad.plano.editor.moveFixings;
        }
    },
    methods: {
        changePositionX(e) {
            this.offsetX = e;
        },
        changePositionY(e) {
            this.offsetY = e;
        },
        validate() {
            this.onCancel();
            this.clearModal();
        },
        cancel() {
            Context.memento.undo();
            this.onCancel();
            this.clearModal();
        },
        clearModal() {
            this.visible = false;
            this.offsetX = 0;
            this.offsetY = 0;
        }
    },
    created() {
        moveItemsWidget = this;
    }
};
</script>

<style scoped lang="scss">
section {
    padding: 20px;
    div {
        display: inline-block;
        margin: 0px 40px;
    }
}
</style>



// WEBPACK FOOTER //
// move_fixings.vue?6b8ea3d8